module.exports = __webpack_public_path__ + "media/19.1fb19daf.mp3";